import { isoZ, z } from 'my-zod'

export const serviceReminderAdjustmentModel = z.object({
  id: z.string(),
  vehicleId: z.number(),
  serviceTaskId: z.number(),
  // ------ delta values for the service task adjustment -----
  mileage: z.number().nullable(),
  engineHours: z.number().nullable(),
  durationDays: z.number().nullable(),
  // ----------------------------------------------------------

  // ----- final values for the service task that outfitter adjusted to -----
  dueDate: isoZ.date().nullable(),
  dueEngineHours: z.number().nullable(),
  dueMileage: z.number().nullable(),
  // -------------------------------------------------------------------------
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type serviceReminderAdjustmentModel = z.infer<typeof serviceReminderAdjustmentModel>

export const ServiceReminderAdjustmentSchemas = {
  serviceReminderAdjustmentModel
}

export declare namespace ServiceReminderAdjustmentSchemas {
  export type serviceReminderAdjustmentModel = z.infer<typeof serviceReminderAdjustmentModel>
}
